export const getPreviousIndex = (index: number, indexesToRemove: number[]): number => {
  let step = 0;
  let previousIndex;
  let previousRemovedIndex;

  // we need to ignore removed indexes
  do {
    step++;
    previousIndex = index - step;
    previousRemovedIndex = indexesToRemove[indexesToRemove.length - step];
  } while (previousRemovedIndex === previousIndex);

  return previousIndex;
};
